'use strict';
// @flow

import { connect } from 'react-redux';

import Funcoes from './funcoes';

export default connect<*, *, *, *, *, *>()(Funcoes);
